"use client";

import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import NavigationSection from "src/components/Common/NavigationSection";

import {
  BrandStrategyHeroData,
  brandStrategyStatsData,
  brandStrategySolutionsAndProcessData,
  brandStrategyPortfolioData,
  brandStrategyTechnologiesData,
  brandStrategyAboutData,
  brandStrategyFaqData,
} from "src/utils/mock/brandStrategyData";
import { marketingServices } from "src/utils/mock/digitalMarketingData";

export default function BrandStrategyComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const strategyProjects = liveProjects.filter((project) => {
    const hasStrategyTech = project.technologies?.some((tech) => ["branding", "marketing", "seo", "design", "strategy", "positioning"].includes(tech.name?.toLowerCase()));
    const isActive = project.projectStatus?.toLowerCase() === "active";
    return hasStrategyTech && isActive;
  });

  const filteredData = {
    ...brandStrategyPortfolioData,
    projects: {
      liveProjects: strategyProjects.length > 0 ? strategyProjects : liveProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;

  return (
    <div>
      <AppHero heroData={BrandStrategyHeroData} />

      <TechStats stats={brandStrategyStatsData} />

      {/* <NavigationSection data={marketingServices} leftHeading="Complete Digital" rightHeading=" Marketing Solutions" /> */}

      <WhyChooseUs data={brandStrategySolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={brandStrategyTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Brand Strategy & Positioning" sections={brandStrategyAboutData} />
        </div>
      </section>

      <FAQSection faqs={brandStrategyFaqData} />

      <CommonContactSection />
    </div>
  );
}
